module.exports = __webpack_public_path__ + "static/patient-support-merk-access-program-00b62aec49d5e7bea9b141bf05811dff.png";